// Status of a marketplace ask/bid. Stored as a smallint column in Postgres.
// A regular (not const) enum so it can be consumed as a value across packages —
// business-web compiles with isolatedModules, which forbids ambient const enums.
//
// OPEN applies to bids that are live but not yet paid (they reserve ask volume
// while awaiting funding). PAID applies to bids that have been successfully
// funded/completed. CLOSED applies to expired, cancelled or otherwise terminal
// bids/asks. PENDING_ADMIN_APPROVAL applies to bids with a counter-offer that
// must be reviewed by an admin before proceeding; these bids do not reserve ask
// volume and never expire.
export var MarketPlaceStatus;
(function (MarketPlaceStatus) {
    MarketPlaceStatus[MarketPlaceStatus["OPEN"] = 0] = "OPEN";
    MarketPlaceStatus[MarketPlaceStatus["CLOSED"] = 1] = "CLOSED";
    MarketPlaceStatus[MarketPlaceStatus["PAID"] = 3] = "PAID";
    MarketPlaceStatus[MarketPlaceStatus["PENDING_ADMIN_APPROVAL"] = 4] = "PENDING_ADMIN_APPROVAL";
})(MarketPlaceStatus || (MarketPlaceStatus = {}));
//# sourceMappingURL=MarketPlaceStatus.js.map